export default __webpack_public_path__ + "static/media/Speedometer.88ce837a.svg";